export default "__VITE_ASSET__D4nU4RaR__"